import axios from 'axios';
import { apiUrl } from './index';

export default {
  getOrder(id) {
    return axios({
      method: 'get',
      url: `${apiUrl}/google_manager/orders/${id}`,
    });
  },
  getOrders(options = {}) {
    const { order_type, search, sort, order, date_filter, ...params } = options;
    const orderType = order_type ?? -1;

    if (orderType > -1) {
      params.order_contract_type = orderType.toString() + '.0';
    }

    if (search && search.length >= 2) {
      params.search = search;
    }

    if (sort) {
      params.sort = sort;
    }

    if (order) {
      params.order = order;
    }

    if (date_filter) {
      params.date_filter = date_filter;
    }

    return axios({
      method: 'get',
      url: `${apiUrl}/google_manager/orders`,
      params,
    });
  },
  getLineItemById({ orderId, lineId }) {
    return axios({
      method: 'get',
      url: `${apiUrl}/google_manager/orders/${orderId}/lines/${lineId}`,
    });
  },
  getAdvertisers(params) {
    return axios({
      method: 'get',
      url: `${apiUrl}/google_manager/advertisers`,
      params,
    });
  },
  getStatuses() {
    return axios({
      method: 'get',
      url: `${apiUrl}/google_manager/orders/statuses`,
    });
  },
  getOrderStatuses() {
    return axios({
      method: 'get',
      url: `${apiUrl}/google_manager/orders/actions`,
    });
  },
  getLineStatuses() {
    return axios({
      method: 'get',
      url: `${apiUrl}/google_manager/lines/actions`,
    });
  },
  getTypes() {
    return axios({
      method: 'get',
      url: `${apiUrl}/google_manager/lines/types`,
    });
  },
  getCostTypes() {
    return axios({
      method: 'get',
      url: `${apiUrl}/google_manager/lines/cost_types`,
    });
  },
  getPlacements(params) {
    // possible params:
    //  business: Boolean
    //  country: String
    return axios({
      method: 'get',
      url: `${apiUrl}/google_manager/targeting/placements`,
      params,
    });
  },
  getPlacementsTypes() {
    return axios({
      method: 'get',
      url: `${apiUrl}/google_manager/targeting/placements-filter-types`,
    });
  },
  getDevices() {
    return axios({
      method: 'get',
      url: `${apiUrl}/google_manager/targeting/devices`,
    });
  },
  getAccountTypes() {
    return axios({
      method: 'get',
      url: `${apiUrl}/google_manager/orders/account_types`,
    });
  },
  getOrderTypes() {
    return axios({
      method: 'get',
      url: `${apiUrl}/google_manager/orders/order-contract-types`,
    });
  },
  getOrderTypesForFilter() {
    return axios({
      method: 'get',
      url: `${apiUrl}/google_manager/orders/all-order-contract-types`,
    });
  },
  getContractNames(options = {}) {
    const {
      country = '',
      search = '',
    } = options;

    const params = {};

    if (search.length > 2) {
      params.title_name_search = search;
    }

    return axios({
      method: 'get',
      url: `${apiUrl}/google_manager/${country}/crm/deals/search`,
      params
    });
  },
  getForecast(options) {
    const {
      lineId,
      cost_type = '',
      country = '',
      start_date = '',
      end_date = '',
      targeting = {},
      type = '',
      units = '',
      frequency_caps = [],
    } = options;

    const formData = {
      country,
      type,
      targeting,
      start_date,
      end_date,
      units,
      cost_type,
      frequency_caps,
    };

    const lineParam = {
      line_id: lineId,
    };

    const data = lineId ? null : formData;
    const params = lineId ? lineParam : null;

    return axios({
      method: 'post',
      url: `${apiUrl}/google_manager/inventory`,
      data,
      params,
    });
  },
  getTargetGroups(country) {
    return axios({
      method: 'get',
      url: `${apiUrl}/google_manager/targeting/groups`,
      params: {
        country
      }
    });
  },
  getTargetUsers() {
    return axios({
      method: 'get',
      url: `${apiUrl}/google_manager/targeting/users`,
    });
  },
  getFreqTimeUnits() {
    return axios({
      method: 'get',
      url: `${apiUrl}/google_manager/lines/frequency_time_units`,
    });
  },
  getGeo(params) {
    return axios({
      method: 'get',
      url: `${apiUrl}/google_manager/targeting/geo`,
      params,
    });
  },
  getThreads(params) {
    return axios({
      method: 'get',
      url: `${apiUrl}/google_manager/threads`,
      params,
    });
  },
  getBusinessMerchants(params) {
    return axios({
      method: 'get',
      url: `${apiUrl}/google_manager/merchants`,
      params,
    });
  },
  addBusinessMerchants({ country, merchants }) {
    return axios({
      method: 'post',
      url: `${apiUrl}/google_manager/merchants`,
      data: {
        merchants,
        country
      },
    });
  },
  // todo: check if country is required
  getGroups(options) {
    const { search = '', country = '' } = options;

    const params = {
      search,
    };

    return axios({
      method: 'get',
      url: `${apiUrl}/pepper/${country}/groups`,
      params,
    });
  },
  createOrder(order) {
    return axios({
      method: 'post',
      url: `${apiUrl}/google_manager/orders`,
      data: {
        ...order,
      },
    });
  },
  updateOrder(order) {
    const { id } = order;
    return axios({
      method: 'put',
      url: `${apiUrl}/google_manager/orders/${id}`,
      data: {
        ...order,
      },
    });
  },
  createLineItem(lineItem) {
    return axios({
      method: 'post',
      url: `${apiUrl}/google_manager/orders/${lineItem.order_id}/lines`,
      data: {
        ...lineItem,
      },
    });
  },
  updateLineItem(lineItem) {
    return axios({
      method: 'put',
      url: `${apiUrl}/google_manager/orders/${lineItem.order_id}/lines/${lineItem.id}`,
      data: {
        ...lineItem,
      },
    });
  },
  updateStatus(order) {
    const { id, statusId } = order;
    return axios({
      method: 'post',
      url: `${apiUrl}/google_manager/orders/${id}/action/${statusId}`,
    });
  },
  updateLineStatus(query) {
    const { orderId, lineItemId, statusId } = query;
    return axios({
      method: 'post',
      url: `${apiUrl}/google_manager/orders/${orderId}/lines/${lineItemId}/action/${statusId}`,
    });
  },
};
